import React from 'react';

const Error = () => {
    return (
        <div>
            <h2>Something went wrong</h2>
        </div>
    );
};

export default Error;